import { BsFiletypeCss, BsFiletypeHtml } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import {
  SiJavascript,
  SiReact,
  SiMongodb,
  SiMysql,
  SiGithub,
  SiExpress,
  SiBootstrap,
  SiAngular,
  SiPhp,
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
  },
  {
    id: 3,
    name: "Bootstrap ",
    icon: SiBootstrap,
  },
  {
    _id: 4,
    name: "MongoDb",
    icon: SiMongodb,
  },
  {
    _id: 5,
    name: "MySQL",
    icon: SiMysql,
  },
  {
    _id: 6,
    name: "Github",
    icon: SiGithub,
  },
  {
    _id: 7,
    name: "Express",
    icon: SiExpress,
  },
  {
    _id: 8,
    name: "React JS",
    icon: SiReact,
  },
  {
    id: 9,
    name: "Nodejs",
    icon: FaNodeJs,
  },
  {
    id: 10,
    name: "JavaScript",
    icon: SiJavascript,
  },

  {
    id: 11,
    name: "Angular ",
    icon: SiAngular,
  },
  {
    id: 12,
    name: "Php ",
    icon: SiPhp,
  },
];
